abstract class Observable {
  protected _observer: Array<() => void> = [];

  public subscribe(callback: () => void): void {
    this._observer.push(callback);
  }

  protected broadcast(): void {
    const ObserverKeys = Object.keys(this._observer);
    for (let i = 0; i < ObserverKeys.length; i += 1) {
      this._observer[i]();
    }
  }
}

export default Observable;
